import { Action, ThunkAction } from "@reduxjs/toolkit";
import { Components, Enums, Models, Services, Types } from "@sendum/core";
import { IMapState } from "./MapReducer";

import { DispatchAction, MapRootState } from "./MapStore";
import { AnyAction } from "redux";

export enum MapActionTypes {
	SET_LOADING_DEVICES,
	ADD_PINS,
	ADD_DEVICES,
	UPDATE_PIN,
	UPDATE_DEVICE_MQTT,
	SET_ERROR,
	CLEAR_DATA,
	RESET_STATE
}

export const resetState = (): DispatchAction => ({
	type: MapActionTypes.RESET_STATE,
	payload: {},
});

export const addPins = (pins: Types.TPin[]): DispatchAction => ({
	type: MapActionTypes.ADD_PINS,
	payload: {
		pins,
	},
});

export const updatePin = (lat: number, lon: number, topic: string, deviceId: string): DispatchAction => ({
	type: MapActionTypes.UPDATE_PIN,
	payload: {
		lat,
		lon,
		topic,
		deviceId,
	},
});

export const addDevices = (devices: Models.Device[]): DispatchAction => ({
	type: MapActionTypes.ADD_DEVICES,
	payload: {
		devices,
	},
});

export const clearData = (): DispatchAction => ({
	type: MapActionTypes.CLEAR_DATA,
	payload: {},
});

export const setLoadingDevices = (newState: boolean): DispatchAction => ({
	type: MapActionTypes.SET_LOADING_DEVICES,
	payload: {
		newState,
	},
});

export const updateDeviceByMqtt = (mess: any, topic: string): DispatchAction => ({
	type: MapActionTypes.UPDATE_DEVICE_MQTT,
	payload: {
		mess,
		topic,
	},
});

export const setError = (error: Error): DispatchAction => ({
	type: MapActionTypes.SET_ERROR,
	payload: {
		error,
	},
});

export const loadDevices = (offset = 0, inBackground = false, clear = false): ThunkAction<void, MapRootState, null, Action<string>> => async (dispatch, getState) => {
	if (!inBackground) {
		await dispatch(setLoadingDevices(true) as unknown as AnyAction);
	}

	const query: Types.TLoadDevicesQuery = {
		view: "map",
		offset,
		limit: 1000,
		search: "",
		shipmentStatus: [],
		deviceStatus: [],
		sortBy: Enums.SortBy.UPDATED_AT,
		sortDirection: Enums.SortDirection.ASC,
	};

	try {
		// const isInitiated = Services.DeviceConfigService.DeviceConfig.getInstance().init(await Services.API.WidgetsApi.getConfig());
		// if (!isInitiated) {
		//   dispatch(setError(new Error(`Widget was not configured completely.`)));
		// }
		const response = await Services.API.WidgetsApi.getDevices(Types.printLoadDevicesQueryToRequest(query));
		if (clear) {
			await dispatch(clearData() as unknown as AnyAction);
			Services.MQTT.unsubscribe();
		}
		await dispatch(addDevices(response.devices) as unknown as AnyAction);
		const state: IMapState = getState().Map;
		const counts = Models.Counts.parse(response.itemsCounts);

		if (!!state.devices && counts.total > state.devices.length) {
			dispatch(loadDevices(state.devices?.length, inBackground) as unknown as AnyAction);
		} else if (!inBackground) {
			await dispatch(setLoadingDevices(false) as unknown as AnyAction);
		}

		await dispatch(addPins(Components.MapUtils.buildPins(response.devices)) as unknown as AnyAction);

		const shipmentsIds: Set<string> = new Set<string>();
		response.devices.forEach(d => {
			if (d?.shipment?.id) {
				shipmentsIds.add(`shipment/${d.shipment.id}`);
			}
		});
		Services.MQTT.unsubscribe();
		Services.MQTT.subscribe(Array.from(shipmentsIds));
	} catch (err) {
		console.error(err);
		if (!inBackground) {
			await dispatch(setLoadingDevices(false) as unknown as AnyAction);
		}
		dispatch(setError(err) as unknown as AnyAction);
	}
};
